import * as React from 'react';
import type { UploadSaleMovementsFilePayload } from 'contracts/restricted-products/restricted-products';
import { api, handleApiError } from 'services';

export const useUploadSaleMovementsFile = () => {
  const uploadSaleMovementsFile = React.useCallback(async (payload: UploadSaleMovementsFilePayload) => {
    const formData = new FormData();
    formData.append('file', payload.file, payload.file.name);
    try {
      await api.post('/restricted-materials/sale-movements/import', formData);
    } catch (error) {
      throw handleApiError(error);
    }

  }, []);

  return {
    uploadSaleMovementsFile
  };
};